<script>
  import BaseModal from "./BaseModal.svelte";
  import { createEventDispatcher } from "svelte";
  import { openAlertModal } from "../utils/AlertHelper.js";
  import InputCategory from "./InputCategory.svelte";

  export let open;
  let latestCategories = [];
  let categories = [];

  let selectedCategory = null;
  let prevCategory;

  let title = "스티커";
  let primaryButtonDisabled = true;

  const dispatch = createEventDispatcher();
  function submit() {
    if (selectedCategory) {
      dispatch("submit", selectedCategory);
    }
  }
  function addCategory() {
    if (categories.length >= 10) {
      openAlertModal({
        width: 400,
        title: "카테고리 초과",
        content:
          "카테고리는 최대 10개까지 추가 가능합니다.<br/>필요없는 카테고리를 삭제해주세요.",
        submit: function (event) {},
      });
      return;
    }
    openAlertModal({
      width: 400,
      title: "스티커 카테고리 추가",
      content: InputCategory,
      contentProps: {
        placeholder: "카테고리 이름을 입력하세요.",
        value: "",
      },
      submit: async function (event) {
        if (event.detail) {
          let categoryJson =
            await window.chrome.webview.hostObjects.sync.penChart.postCategory(
              JSON.stringify({ Name: event.detail })
            );
          let category = JSON.parse(categoryJson);
          categories = [category, ...categories];
        }
      },
    });
  }
  function selectCategory(category) {
    selectedCategory = category;
  }

  $: if (open) {
    try {
      const jsonStr =
        window.chrome.webview.hostObjects.sync.penChart.getCategories();
      categories = JSON.parse(jsonStr);
    } catch (err) {
      openAlertModal({
        title: "오류",
        content: "카테고리를 불러오는 데 실패했습니다.",
      });
    }
  }

  $: primaryButtonDisabled = selectedCategory == null;
  $: if (selectedCategory !== prevCategory) {
    prevCategory = selectedCategory;
  }
  $: if (open == false) {
    selectedCategory = null;
  }
</script>

<BaseModal
  width={556}
  bind:show={open}
  onClose={() => (open = false)}
  bind:title
  disableOverlayClose={true}
  bind:primaryButtonDisabled
  on:submit={submit}
>
  <div class="category-section">
    <div class="category-list-section">
      <div class="category-title">카테고리</div>
      <div class="category-list">
        {#each categories as category, i}
          <div
            class="category-item"
            class:active={selectedCategory?.Id == category.Id}
            on:click={selectCategory(category)}
          >
            <span class="category-icon"
              ><svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="36" height="36" rx="18" fill="#828691" />
                <path
                  d="M14.5381 10.7998C15.2256 10.7998 15.5697 10.7999 15.8828 10.9209C16.1961 11.042 16.451 11.2737 16.96 11.7363L17.9102 12.5996H26.0996C26.5967 12.5996 27 13.0029 27 13.5V24.2998C27 24.7969 26.5967 25.2002 26.0996 25.2002H9.90039C9.40333 25.2002 9 24.7969 9 24.2998V13.5L9.00195 12.9443C9.00838 12.4572 9.03399 12.1592 9.13672 11.9111C9.3194 11.4701 9.67029 11.1202 10.1113 10.9375C10.4421 10.8005 10.8615 10.7998 11.7002 10.7998H14.5381Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="category-name">{category.Name}</span>
          </div>
        {/each}

        <div class="category-item" on:click={addCategory}>
          <span class="category-icon"
            ><svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.9"
                y="0.9"
                width="34.2"
                height="34.2"
                rx="17.1"
                fill="white"
              />
              <rect
                x="0.9"
                y="0.9"
                width="34.2"
                height="34.2"
                rx="17.1"
                stroke="#C1C1C1"
                stroke-width="1.8"
              />
              <path
                d="M12.1499 17.6688H23.8499M18.1063 12.1499V23.8499"
                stroke="#C1C1C1"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="category-name">카테고리 추가</span>
        </div>
      </div>
    </div>
  </div>
</BaseModal>

<style scoped>
  .category-title {
    font-weight: 500;
    font-size: 16px;
    color: #1d2226;
    margin-bottom: 12px;
  }
  .category-list {
    max-height: 386px;
  }
  .category-item {
    width: 516px;
    height: 61px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    gap: 20px;
    cursor: pointer;
  }
  .category-item.active {
    border: 3px solid #3b5998;
  }
  .category-item:hover {
    background: #f5f7fa;
  }
  .category-item:last-child {
    border-bottom: none;
  }
  .category-name {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #1d2226;
    letter-spacing: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .latest-section {
    margin-bottom: 12px;
  }
  .latest-title {
    font-weight: 500;
    font-size: 16px;
    color: #1d2226;
    margin-bottom: 12px;
  }
  .latest-list {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
  }
  .latest-item {
    width: 120px;
    height: 120px;
    background: #eaecef;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #eaeaea;
  }
  .latest-item.active {
    border: 3px solid #3b5998;
  }
  .latest-divider {
    border-bottom: 1px solid #e0e0e0;
    margin: 0 0 16px 0;
  }
  .category-list-section {
    min-height: 457px;
  }
  .sticker-section {
    min-height: 457px;
  }
</style>
